import { createAction } from 'redux-actions';
export const ADD_PASSENGER = 'ADD_PASSENGER';
export const REMOVE_PASSENGER = 'REMOVE_PASSENGER';
export const SET_PASSENGERS = 'SET_PASSENGERS';
export const CLEAR_PASSENGERS = 'CLEAR_PASSENGERS';
export const addPassenger = createAction(ADD_PASSENGER);
export const removePassenger = createAction(REMOVE_PASSENGER);
export const setPassengers = createAction(SET_PASSENGERS, (passengers) => passengers);
export const clearPassengers = createAction(CLEAR_PASSENGERS);
